import API from './index';

const api = {
    getReportDetail(params) {
        return API.authAPI({
            url: '/approval/get-report-detail',
            method: 'GET',
            params: { ...params },
        });
    },
    saveProgressReport(data) {
        return API.authAPI({
            url: '/approval/save-progress',
            method: 'POST',
            data,
        });
    },
    submitProgressReport(data) {
        return API.authAPI({
            url: '/approval/submit-progress',
            method: 'POST',
            data,
        });
    },
    // saveMiscellaneous(data) {
    //     return API.authAPI({
    //         url: '/approval/save-miscellaneous',
    //         method: 'POST',
    //         data,
    //     });
    // },
    // submitMiscellaneous(data) {
    //     return API.authAPI({
    //         url: '/approval/submit-miscellaneous',
    //         method: 'POST',
    //         data,
    //     });
    // },
};

export default api;
